import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ProblemReasonBox from './ProblemReasonBox';
import parse from 'html-react-parser';

function CounselingSecColSubChild({
  editModeEnabled,
  data,
  subData,
  checkBoxData,
  checkboxRef,
  handleCheckBoxLable,
  handleCheckBoxChange,
  handleRemoveSubChild,
  handleEditSubChild,
  moduleName,
  allData,
}) {
  const [curPblmReason, setCurPblmReason] = useState(false);
  const [popupData, setPopUpData] = useState([]);
  const handleOpenPopup = (lbl, reson) => {
    setCurPblmReason(true);
    setPopUpData([lbl, reson]);
  };
  return (
    <div className="sec-col-ht">
      <div className="sec-col-parnt-cont">
        {subData[2] &&
          subData[2]?.map((childData, k) => (
            <div
              key={k}
              className={`chld-rw qcontent-line-break ${moduleName}MasterSubChildData_${data[3]}_${subData[0]}`}
              id={`${moduleName}SubChildDataListInpt_${data[3]}_${subData[0]}_${childData?.child_id}`}
              data-search-term={childData?.child_texte}
              attr={childData?.sub_type || 0}
            >
              <span className="">
                {childData?.sub_type && parseInt(childData?.sub_type) === 1 ? (
                  <span className="clear-left15"></span>
                ) : (
                  <input
                    type="checkbox"
                    className={`${moduleName}SubChildDataList_${data[3]}_${subData[0]}`}
                    id={`${moduleName}SubChildDataListInpt_${data[3]}_${subData[0]}_${childData?.child_id}`}
                    checked={
                      !!(
                        checkBoxData &&
                        checkBoxData[
                          `${moduleName}SubChildDataListInpt_${data[3]}_${subData[0]}_${childData?.child_id}`
                        ]
                      )
                    }
                    ref={(el) =>
                      (checkboxRef.current[
                        `${moduleName}SubChildDataListInpt_${data[3]}_${subData[0]}_${childData?.child_id}`
                      ] = el)
                    }
                    onChange={(e) => handleCheckBoxChange(e, childData)}
                  />
                )}
              </span>
              <span className="chld-rw-txt grid-sec">
                <span
                  className="content-line-break"
                  id={`${moduleName}SubChildDataList_${data[3]}_${subData[0]}_${childData?.child_id}`}
                  onClick={() =>
                    handleCheckBoxLable(
                      `${moduleName}SubChildDataListInpt_${data[3]}_${subData[0]}_${childData?.child_id}`,
                      childData,
                    )
                  }
                  // dangerouslySetInnerHTML={{
                  //   __html: childData?.child_texte.replace(/<br\s*\/?>/gi, ''),
                  // }}
                >
                  {parse(childData?.child_texte)}
                </span>
                <span
                  id={`${moduleName}diagReason_${data[3]}_${subData[0]}_${childData?.child_id}`}
                  style={{ display: 'none' }}
                >
                  {allData?.reasonArr &&
                    `${
                      allData?.reasonArr &&
                      allData?.reasonArr[childData?.child_id]
                    }`}
                </span>
                <span className="clear7 med-label">
                  {allData?.reasonArr && (
                    <div className="chld-rw-txt">
                      {allData?.reasonArr[childData?.child_id] &&
                      allData?.reasonArr[childData?.child_id].length > 20 ? (
                        <>
                          {allData?.reasonArr[childData?.child_id].slice(0, 20)}
                          {'...'}
                          <span
                            className="smart-tag-name"
                            onClick={() =>
                              handleOpenPopup(
                                childData?.child_texte,
                                allData?.reasonArr[childData?.child_id],
                              )
                            }
                          >
                            see more
                          </span>
                        </>
                      ) : (
                        allData?.reasonArr[childData?.child_id]
                      )}
                      {curPblmReason && (
                        <ProblemReasonBox
                          reasonNote={popupData}
                          onCancelReason={() => setCurPblmReason(false)}
                        />
                      )}
                    </div>
                  )}
                </span>
              </span>
              {editModeEnabled && (
                <>
                  <span
                    // className={
                    //   childData?.sub_type && parseInt(childData?.sub_type) === 1
                    //     ? 'hide'
                    //     : ''
                    // }
                    style={{ width: '10%' }}
                    onClick={() =>
                      handleRemoveSubChild(
                        `${data[3]}_${subData[0]}_${childData?.child_id}`,
                      )
                    }
                  >
                    <Link>&#10007;</Link>
                  </span>
                  <span
                    className={
                      childData?.sub_type && parseInt(childData?.sub_type) === 1
                        ? ''
                        : ''
                    }
                    onClick={() =>
                      handleEditSubChild([
                        data[3],
                        subData[0],
                        childData?.child_id,
                        childData?.child_texte,
                        childData?.sub_type,
                      ])
                    }
                  >
                    <Link>✎</Link>
                  </span>
                </>
              )}
            </div>
          ))}
      </div>
    </div>
  );
}

export default CounselingSecColSubChild;
